export const RESET_CSS = `
::backdrop {
	--richtext-border-spacing-x: 0;
	--richtext-border-spacing-y: 0;
	--richtext-translate-x: 0;
	--richtext-translate-y: 0;
	--richtext-rotate: 0;
	--richtext-skew-x: 0;
	--richtext-skew-y: 0;
	--richtext-scale-x: 1;
	--richtext-scale-y: 1;
	--richtext-pan-x: ;
	--richtext-pan-y: ;
	--richtext-pinch-zoom: ;
	--richtext-scroll-snap-strictness: proximity;
	--richtext-gradient-from-position: ;
	--richtext-gradient-via-position: ;
	--richtext-gradient-to-position: ;
	--richtext-ordinal: ;
	--richtext-slashed-zero: ;
	--richtext-numeric-figure: ;
	--richtext-numeric-spacing: ;
	--richtext-numeric-fraction: ;
	--richtext-ring-inset: ;
	--richtext-ring-offset-width: 0px;
	--richtext-ring-offset-color: #fff;
	--richtext-ring-color: rgb(59 130 246 / 0.5);
	--richtext-ring-offset-shadow: 0 0 #0000;
	--richtext-ring-shadow: 0 0 #0000;
	--richtext-shadow: 0 0 #0000;
	--richtext-shadow-colored: 0 0 #0000;
	--richtext-blur: ;
	--richtext-brightness: ;
	--richtext-contrast: ;
	--richtext-grayscale: ;
	--richtext-hue-rotate: ;
	--richtext-invert: ;
	--richtext-saturate: ;
	--richtext-sepia: ;
	--richtext-drop-shadow: ;
	--richtext-backdrop-blur: ;
	--richtext-backdrop-brightness: ;
	--richtext-backdrop-contrast: ;
	--richtext-backdrop-grayscale: ;
	--richtext-backdrop-hue-rotate: ;
	--richtext-backdrop-invert: ;
	--richtext-backdrop-opacity: ;
	--richtext-backdrop-saturate: ;
	--richtext-backdrop-sepia: ;
	--richtext-contain-size: ;
	--richtext-contain-layout: ;
	--richtext-contain-paint: ;
	--richtext-contain-style: ;
}
.reactjs-tiptap-editor {
  button,
  input:where([type=button]),
  input:where([type=reset]),
  input:where([type=submit]) {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none
  }

  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
  }

  button {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
  }
}

.reactjs-tiptap-editor,
div[data-radix-popper-content-wrapper],
div[data-tippy-root] {
*,
:before,
:after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
}

background-color: hsl(var(--richtext-background));
color: hsl(var(--richtext-foreground));


html,
:host {
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  -moz-tab-size: 4;
  tab-size: 4;
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol, "Noto Color Emoji";
  font-feature-settings: normal;
  font-variation-settings: normal;
  -webkit-tap-highlight-color: transparent
}

hr {
  height: 0;
  color: inherit;
  border-top-width: 1px
}

b,
strong {
  font-weight: bolder
}

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
  font-feature-settings: normal;
  font-variation-settings: normal;
  font-size: 1em
}

input, textarea {
  border-width: 1px;
}

textarea {
  resize: vertical
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  color: #9ca3af
}

button, input, textarea {
  cursor: pointer;
  color: inherit;
}

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle
}

img,
video {
  max-width: 100%;
  height: auto
}
}

.richtext-border-custom {
  border: 1px #dadada solid !important;
}

.richtext-toolbar-border {
  border-bottom: 1px #dadada solid !important;
}

.richtext-apply-button {
  color: white !important;
}

.reactjs-tiptap-editor.reactjs-tiptap-editor .tableWrapper table, td, tr {
    position: relative;
    box-sizing: border-box;
    border: 0.25px solid #0000001a;
    margin: 0;
}
.reactjs-tiptap-editor .search-result {
  background: #c4eed0;
}

.reactjs-tiptap-editor .search-result-current {
    background: #6cd58b !important;
}
`;
